import React from "react"
import { Grid } from "@mui/material"
import { AppFormSection } from "@components"

import { AlertsBaseDrawer, AlertsConditionName, AlertsDrawerBaseFooter, AlertsSitesRequired } from "Pages/ReportsAlerts/Alerts/Conditions/@components"
import Comparator from "Pages/ReportsAlerts/Alerts/Conditions/Rating/Drawer/Comparator"
import AlertsComparatorValue from "Pages/ReportsAlerts/Alerts/Conditions/Rating/Drawer/ComparatorValue"
import RatingAlertsProviders from "Pages/ReportsAlerts/Alerts/Conditions/Rating/Drawer/RatingAlertsProviders"


export default function RatingDrawer({ onSubmitAlert, isLoading }) {

	return <AlertsBaseDrawer
		footer={<AlertsDrawerBaseFooter onSubmitAlert={onSubmitAlert} isLoading={isLoading}/>}
		content={<>
			<AppFormSection icon="tag" title="Condition">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-rt-name">
					<AlertsConditionName/>
				</Grid>
				</Grid>
			</AppFormSection>
			<AppFormSection icon="globe" title="Sites">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-rt-sites">
					<AlertsSitesRequired/>
				</Grid>
				<Grid item xs={12}/>
				<Grid item xs={12} data-tour-id="cond-rt-providers">
					<RatingAlertsProviders/>
				</Grid>
				<Grid item xs={6} data-tour-id="cond-rt-comparator">
					<Comparator/>
				</Grid>
				<Grid item xs={6} data-tour-id="cond-rt-comp-value">
					<AlertsComparatorValue/>
				</Grid>
				</Grid>
			</AppFormSection>
		</>}/>
}